export const splitBoldAndRegularText = (input: string): { boldText: string; restText: string } => {
    const boldMatch = input.match(/<b>(.*?)<\/b>/);
    const boldText = boldMatch ? boldMatch[1] : '';
    const restText = input.replace(/<b>.*?<\/b>\s*/, '');

    return { boldText, restText };
}